// The one definition of what Sayer may and may not use live web search for.
//
// WHY A SHARED MODULE. Both chat classifiers (`classifyChatIntent` with a forecast open,
// `classifyPreforecastIntent` without) need the same boundary, and the boundary is the whole
// point: search is there to answer world questions the forecast material cannot, and must
// never become a route to second-guessing the forecaster's number. If the two prompts stated
// that differently, the same question would get a different policy depending on whether a
// forecast happened to be open.
//
// WHY IT NEEDS SAYING AT ALL. The capability has been on for a while — chatboard sends a bare
// `{prompt}`, which the forecast server serves on its default-model path with OpenRouter's
// native web plugin attached. But nothing in either prompt mentioned it, while both DID say
// "answer from the material above" / "never invent facts", so the model reliably declined to
// search. Capability without permission reads, to the model, as no capability.

/**
 * The WEB SEARCH prompt section.
 *
 * @param {boolean} enabled whether the request will actually carry the search plugin — pass
 *   the same flag `callLlm({webSearch})` gets, so the prompt can never promise a tool the
 *   request withheld (a model told it can search, whose request has no plugin, answers from
 *   stale parametric memory and presents it as looked-up).
 * @returns {string} a prompt block, no trailing newline
 */
export function webSearchClause(enabled) {
  if (!enabled) {
    return `WEB SEARCH: unavailable this turn.
Answer only from the material above and the conversation. If the user asks for a fact you do not have, say plainly that you do not have it — do not guess, and do not present recalled information as current.`;
  }
  return `WEB SEARCH: available. You can look things up on the web.
- USE it for world facts the material above does not contain: a recent event, a current price or reading, a today's-date-dependent fact, a detail about an entity the report does not cover. When you do, say plainly that it is current information from the web.
- DO NOT use it to check, revise, second-guess, or "update" this forecast's probability, its drivers, or its resolution criteria. The forecaster owns that number and the reasoning behind it. "Why is it NN%?", "what's driving it?", and "which sources back it?" are answered from the material above and from nothing else.
- DO NOT tell the user the forecast looks wrong because of something you found. If a search result seems to cut against the forecast, you may mention the fact neutrally, but never restate the probability yourself.
- Whatever you look up, your reply must STILL be only the JSON object described below — no citations markup, no prose outside the JSON, no backticks.`;
}
